<template>
  <div v-resize="onResize" class="horizontal-scroll">
    <button
      type="button"
      class="horizontal-scroll__back-button"
      :class="{
        'horizontal-scroll__back-button--disabled': disableHorizontalScroll
      }"
      :disabled="isScrollBoxLeftEdge || null"
      @click="onClickBackButton"
    >
      <ChevronBack
        class="horizontal-scroll__chevron-back"
        :disabled="isScrollBoxLeftEdge || null"
      />
    </button>
    <div
      :ref="refName"
      v-scroll="onScroll"
      class="horizontal-scroll__scroll-box"
    >
      <slot />
    </div>
    <button
      type="button"
      class="horizontal-scroll__prev-button"
      :class="{
        'horizontal-scroll__prev-button--disabled': disableHorizontalScroll
      }"
      :disabled="isScrollBoxRightEdge || null"
      @click="onClickPrevButton"
    >
      <ChevronForward
        class="horizontal-scroll__chevron-forward"
        :disabled="isScrollBoxRightEdge || null"
      />
    </button>
  </div>
</template>
<script>
import ChevronBack from '../../atoms/svg_icons/ChevronBack.vue'
import ChevronForward from '../../atoms/svg_icons/ChevronForward.vue'
export default {
  components: { ChevronBack, ChevronForward },
  props: {
    initialized: {
      type: Boolean,
      required: false,
      default: true
    },
    refName: {
      type: String,
      required: true
    },
    scrollAmount: {
      type: Number,
      required: false,
      default: 160
    }
  },
  data() {
    return {
      scrollBoxScrollLeft: 0,
      scrollBoxScrollWidth: 0,
      scrollBoxClientWidth: 0
    }
  },
  computed: {
    isScrollBoxLeftEdge() {
      return this.scrollBoxScrollLeft === 0
    },
    isScrollBoxRightEdge() {
      return (
        this.scrollBoxScrollWidth ===
        this.scrollBoxScrollLeft + this.scrollBoxClientWidth
      )
    },
    disableHorizontalScroll() {
      return this.scrollBoxClientWidth >= this.scrollBoxScrollWidth
    }
  },
  mounted() {
    this.initializeValues()
  },
  methods: {
    onClickBackButton() {
      const target = this.$refs[this.refName]
      target.scroll(target.scrollLeft - this.scrollAmount, 0)
    },
    onClickPrevButton() {
      const target = this.$refs[this.refName]
      target.scroll(target.scrollLeft + this.scrollAmount, 0)
    },
    onScroll() {
      this.scrollBoxScrollLeft = this.$refs[this.refName].scrollLeft
    },
    // NOTE: このコンポーネントを利用する側で、slot する要素がmountされた後にこの関数を実行する必要がある
    initializeValues() {
      const target = this.$refs[this.refName]
      this.scrollBoxScrollLeft = target.scrollLeft
      this.scrollBoxScrollWidth = target.scrollWidth
      this.scrollBoxClientWidth = target.clientWidth
    },
    onResize() {
      this.initializeValues()
    },
    // NOTE: 外部からスクロールを制御するための関数
    scrollTo(xCoordinate) {
      this.$refs[this.refName].scrollTo(xCoordinate, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.horizontal-scroll {
  display: flex;
  justify-items: center;
  align-items: center;

  &__back-button,
  &__prev-button {
    @extend %hover-common;
    width: 32px;
    height: 32px;
    border: 2px solid $link;
    box-sizing: border-box;
    border-radius: 40px;
    cursor: pointer;

    &:active {
      opacity: 0.5;
    }

    &[disabled] {
      border-color: $gray-2;

      &:hover {
        opacity: 1;
      }

      &:active {
        opacity: 1;
      }
    }
  }

  &__back-button {
    margin-right: 24px;
  }

  &__prev-button {
    margin-left: 24px;
  }

  &__back-button,
  &__prev-button {
    @media all and (max-width: ($base-contents-width - 1)) {
      display: none;
    }

    &--disabled {
      display: none;
    }
  }

  &__scroll-box {
    @extend %custom-scrollbar;

    flex: 1;
    overflow-x: scroll;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
  }

  &__chevron-back,
  &__chevron-forward {
    fill: $link;

    &[disabled] {
      fill: $gray-2;
    }
  }
}
</style>
